import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';
import { linkForNamedEntity } from '../utils/category-page';

export function selectEpoch(state, id) {
  return state.entities.epochs[id];
}

export const selectEpochs = createSelector(
  [state => state.entities, state => state.lists.epochs.entities],
  (entities, epochs) => assembleEntity(Schema.EpochList, entities, epochs)
);

export const selectEpochLinks = createSelector([selectEpochs], epochs =>
  epochs.map(linkForNamedEntity('periods'))
);
